import {Injectable  } from '@angular/core';
import {Router,CanActivate,ActivatedRouteSnapshot,RouterStateSnapshot  } from '@angular/router';
import { KEYS } from '../shared/constants/keys';

@Injectable()
export class AuthGuard implements CanActivate{

    constructor(private router :Router){}

    canActivate(router :ActivatedRouteSnapshot,state:RouterStateSnapshot)
    {
        if(localStorage.getItem(KEYS.ACCESS_TOKEN)){
            console.log('Auth guard is Returning true');
            return true;
        }
        this.router.navigate(['/login'],{queryParams:{returnUrl: state.url}})
        console.log('Auth guard is Returning false');
        return false;
    }
}